var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPresentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 1024,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.26738527 -0.00380567 2.53477054 -0.00761134 3.84056142 -0.01153234 C7.36252684 -0.02181375 10.88439177 -0.01965836 14.40636568 -0.01547697 C18.2365604 -0.0131117 22.06673039 -0.02227859 25.89691573 -0.02996117 C32.61132929 -0.04181137 39.32571567 -0.04617381 46.0401392 -0.04563999 C56.02489182 -0.04484706 66.0096101 -0.0553935 75.99435354 -0.06805556 C95.9039271 -0.09280169 115.81349232 -0.10157893 135.72307914 -0.10659205 C136.75428046 -0.10685322 137.78548178 -0.1071144 138.84793162 -0.10738349 C139.88118779 -0.10764376 140.91444396 -0.10790404 141.97901091 -0.1081722 C153.42581234 -0.11125368 164.87261145 -0.11775812 176.31941128 -0.12438488 C210.88788426 -0.14403307 245.45635475 -0.1604374 280.02483368 -0.16326141 C281.13064842 -0.16335547 282.23646316 -0.16344954 283.37578744 -0.16354645 C287.85723754 -0.16392493 292.33868764 -0.16428893 296.82013775 -0.16464943 C300.19321395 -0.16492115 303.56629014 -0.16519782 306.93936634 -0.16547489 C308.05395936 -0.16556291 309.16855238 -0.16565094 310.31692095 -0.16574163 C345.34115934 -0.16864732 380.36534255 -0.19074522 415.38956165 -0.22699833 C454.72950345 -0.26771745 494.06940765 -0.29141992 533.40937167 -0.29172093 C537.60367891 -0.29181775 541.79798613 -0.29198447 545.99229336 -0.29220104 C547.02505534 -0.29224516 548.05781732 -0.29228927 549.12187512 -0.29233472 C565.74735071 -0.29345494 582.37277105 -0.31086902 598.99822885 -0.33402036 C615.70549798 -0.35685416 632.41269241 -0.36109374 649.11997142 -0.34647106 C659.04672894 -0.33831508 668.97325127 -0.34402657 678.8999803 -0.36965191 C685.53194488 -0.38539125 692.16374231 -0.38293906 698.79570284 -0.36574518 C702.57374337 -0.35646326 706.3513306 -0.35500981 710.12933596 -0.37571125 C714.20376759 -0.39784678 718.27713711 -0.38112026 722.35157776 -0.36076355 C723.51810305 -0.37332692 724.68462835 -0.3858903 725.88650289 -0.39883438 C737.611775 -0.27329856 746.87526003 3.66930013 755.29507923 11.79131222 C761.92344882 19.24527944 766.32090332 28.15855261 766.49039173 38.26006222 C765.67013444 49.25758588 761.92200736 59.79570985 753.49039173 67.26006222 C742.74370371 74.74127751 733.46204615 76.43637469 720.55289173 76.32256222 C718.81062023 76.31118733 717.06834599 76.30022599 715.32606983 76.28958797 C714.42037974 76.28403613 713.51468966 76.27848429 712.58155441 76.27276421 C711.89147073 76.26857255 711.20138704 76.26438089 710.49039173 76.26006222 C710.51998919 76.80189396 710.54958664 77.3437257 710.58008099 77.90197659 C711.85733777 102.65761294 711.63783864 127.43933049 711.62471724 152.21954823 C711.62215329 158.59002759 711.62454202 164.96050564 711.6261034 171.33098507 C711.62802764 182.69247413 711.62495816 194.05395449 711.61984406 205.41544181 C711.61536955 215.67322276 711.6161621 225.9309924 711.62076283 236.18877316 C711.62613756 248.17746248 711.62809471 260.1661433 711.62515056 272.15483427 C711.62360184 278.47355864 711.62335533 284.79227525 711.62668705 291.11099911 C711.62959978 297.04727477 711.62752829 302.98352927 711.62179279 308.91980267 C711.62048378 311.08234656 711.62082719 313.24489227 711.62305546 315.40743542 C711.63249071 325.50371786 711.56723237 335.57882486 711.05652332 345.66399288 C711.00077631 346.78329134 711.00077631 346.78329134 710.94390309 347.92520189 C709.22685751 377.88165408 696.70384491 404.54997684 677.49039173 427.26006222 C676.51070862 428.4888173 675.53142972 429.71789501 674.55289173 430.94756222 C673.87226673 431.71068722 673.19164173 432.47381222 672.49039173 433.26006222 C671.83039173 433.26006222 671.17039173 433.26006222 670.49039173 433.26006222 C670.49039173 433.92006222 670.49039173 434.58006222 670.49039173 435.26006222 C643.34105159 460.60288733 610.73889404 471.00532658 574.19620228 470.71416378 C572.16357413 470.71303163 570.13094436 470.71367631 568.09831715 470.7159338 C562.65330488 470.71706754 557.20865505 470.69377866 551.763726 470.66563797 C546.04631662 470.64039756 540.32889621 470.63826466 534.6114397 470.63353634 C523.8172733 470.62117241 513.02327162 470.58844114 502.2291773 470.54813838 C487.62006774 470.49479136 473.01091218 470.47342193 458.40172958 470.45012951 C435.43116058 470.41267403 412.46093896 470.3329396 389.49039173 470.26006222 C389.49039173 521.41006222 389.49039173 572.56006222 389.49039173 625.26006222 C391.14039173 624.93006222 392.79039173 624.60006222 394.49039173 624.26006222 C396.70144863 624.16966336 398.91493932 624.13217836 401.1278429 624.13066769 C401.77621616 624.12891537 402.42458942 624.12716305 403.09261036 624.12535763 C405.23955437 624.12095737 407.38641558 624.12388065 409.53336048 624.12724972 C411.05902083 624.12657382 412.58468108 624.12560143 414.11034107 624.12435055 C417.32744834 624.12287411 420.54452792 624.12501784 423.76163197 624.12969112 C427.77371451 624.13525036 431.78572873 624.13209861 435.79780865 624.12625408 C452.28088663 624.1058795 468.75176043 624.23312312 485.22867298 624.70537472 C486.28856465 624.73449759 486.28856465 624.73449759 487.36986828 624.76420879 C514.53467149 625.53060834 514.53467149 625.53060834 524.49039173 635.26006222 C526.04645799 637.53273794 527.23296726 639.7901213 528.49039173 642.26006222 C528.84746204 642.84400753 529.20453236 643.42795284 529.57242298 644.02959347 C532.00293136 649.93521169 531.38026568 658.21303847 529.61539173 664.25615597 C526.42150647 671.15873037 521.7834768 675.91430599 514.86539173 679.07256222 C510.28890603 680.68280719 506.21760952 681.38457919 501.37404823 681.39148998 C500.36007526 681.39533113 499.34610229 681.39917227 498.30140287 681.40312982 C497.19441327 681.40226333 496.08742366 681.40139685 494.94688892 681.40050411 C493.17471895 681.4049608 493.17471895 681.4049608 491.36674756 681.40950751 C488.09088562 681.41667944 484.81505566 681.41936618 481.53918707 681.42010498 C478.00462072 681.42195836 474.47006567 681.42950714 470.93550587 681.4362402 C463.20810579 681.4498127 455.48071091 681.45584659 447.75330091 681.46025085 C442.92640241 681.46301519 438.09950591 681.4672529 433.27260876 681.47175503 C419.90305456 681.48394643 406.53350197 681.4942459 393.16394234 681.49763012 C392.3085263 681.49784969 391.45311026 681.49806925 390.57177253 681.49829547 C389.7143327 681.49851375 388.85689288 681.49873203 387.97347003 681.49895692 C386.23602792 681.49940038 384.4985858 681.49984694 382.76114368 681.50029659 C381.46840218 681.50062874 381.46840218 681.50062874 380.14954468 681.50096759 C366.18889693 681.50491452 352.22830141 681.52236591 338.26767383 681.54565611 C323.92760781 681.56938582 309.58756797 681.58183271 295.247482 681.58299804 C287.1988536 681.5839139 279.15029325 681.5896439 271.10168362 681.60781765 C264.24729742 681.62324052 257.39300032 681.62832624 250.53860006 681.62007955 C247.04367444 681.61618072 243.5489281 681.61706485 240.0540247 681.63113689 C236.25880023 681.64384202 232.46403413 681.63798669 228.66881275 681.62755489 C227.57297676 681.6356113 226.47714077 681.6436677 225.34809762 681.65196824 C214.38576868 681.58162821 206.58435652 679.44090247 198.62711048 671.72099972 C193.60603346 665.9380408 191.18039458 658.93249173 191.49039173 651.26006222 C192.97143352 642.11747732 197.29700117 635.32952104 204.74039173 629.88506222 C212.28483473 624.65073936 222.27690357 624.97148463 231.09048939 625.03301144 C232.76054035 625.03257336 232.76054035 625.03257336 234.46432972 625.03212643 C238.1111197 625.03350966 241.75770035 625.04902331 245.40445423 625.06474972 C247.9460689 625.06848343 250.48768502 625.07132871 253.02930164 625.07332516 C259.01430841 625.08015755 264.99922658 625.09588889 270.98419797 625.11602414 C277.80412036 625.13846493 284.62404649 625.14939703 291.44399667 625.15941501 C305.45951006 625.18025781 319.47493021 625.21690094 333.49039173 625.26006222 C333.49039173 618.00006222 333.49039173 610.74006222 333.49039173 603.26006222 C332.83039173 603.26006222 332.17039173 603.26006222 331.49039173 603.26006222 C331.82039173 602.60006222 332.15039173 601.94006222 332.49039173 601.26006222 C332.57859015 598.45945433 332.60559429 595.68408079 332.58804798 592.88359737 C332.58585758 591.5800153 332.58585758 591.5800153 332.58362293 590.25009823 C332.57980608 588.35183939 332.57367824 586.45358416 332.56555653 584.55533886 C332.55273717 581.51243795 332.5462585 578.4695811 332.54141712 575.42665768 C332.52806417 567.8356825 332.50439121 560.24474667 332.48001575 552.65380001 C332.45985519 546.28755424 332.44437483 539.92132681 332.43445301 533.55505657 C332.4281924 530.62723387 332.41567136 527.69948887 332.40274525 524.77168941 C332.35488096 506.5913539 332.92540686 488.42961631 333.49039173 470.26006222 C332.43169754 470.26374939 331.37300335 470.26743656 330.28222752 470.27123547 C304.44684768 470.36028253 278.61148789 470.42588286 252.77598667 470.46731091 C240.28180688 470.48788093 227.78772884 470.51589457 215.29361439 470.56182003 C204.3957586 470.6018587 193.49797656 470.62753537 182.60004926 470.6364162 C176.83692013 470.64160224 171.07400187 470.65367385 165.31094074 470.68298244 C159.87069877 470.71042142 154.43075166 470.7184505 148.99044704 470.71249294 C147.00893576 470.71358058 145.02741313 470.72136284 143.04596233 470.73688412 C106.28959913 471.01033611 75.7964597 457.84293932 49.49039173 432.26006222 C41.33306435 423.86543076 35.06806498 414.36047647 28.97086048 404.41240597 C27.66861407 402.14772177 27.66861407 402.14772177 25.49039173 401.26006222 C25.1396317 399.59697584 24.81052242 397.92931511 24.49039173 396.26006222 C23.60624685 394.03850832 22.68520177 391.83150204 21.74039173 389.63506222 C19.24746508 383.61922458 17.2922339 377.55128924 15.61539173 371.26006222 C15.40044056 370.47163937 15.18548939 369.68321651 14.96402454 368.87090206 C13.76264324 364.19742949 13.27230992 360.08351873 13.49039173 355.26006222 C12.50039173 354.93006222 11.51039173 354.60006222 10.49039173 354.26006222 C10.82039173 353.93006222 11.15039173 353.60006222 11.49039173 353.26006222 C11.79563135 348.60917507 11.79563135 348.60917507 10.49039173 344.26006222 C10.57877634 341.88223116 10.73385594 339.50661076 10.92789173 337.13506222 C11.02972767 335.85373409 11.13156361 334.57240597 11.23648548 333.25224972 C11.32027454 332.26482784 11.40406361 331.27740597 11.49039173 330.26006222 C10.83039173 330.26006222 10.17039173 330.26006222 9.49039173 330.26006222 C9.65337757 329.72542355 9.81636341 329.19078487 9.98428822 328.63994503 C10.59540243 325.76626371 10.60245223 323.12040468 10.58804798 320.18193722 C10.58482533 319.02178097 10.58160267 317.86162472 10.57828236 316.66631222 C10.56990345 315.45974972 10.56152454 314.25318722 10.55289173 313.01006222 C10.54838001 311.78803097 10.54386829 310.56599972 10.53921986 309.30693722 C10.52743988 306.29126276 10.51099026 303.27568724 10.49039173 300.26006222 C10.16039173 300.26006222 9.83039173 300.26006222 9.49039173 300.26006222 C9.49039173 295.31006222 9.49039173 290.36006222 9.49039173 285.26006222 C9.82039173 285.26006222 10.15039173 285.26006222 10.49039173 285.26006222 C10.98539173 275.85506222 10.98539173 275.85506222 11.49039173 266.26006222 C10.83039173 266.26006222 10.17039173 266.26006222 9.49039173 266.26006222 C9.63476673 265.70318722 9.77914173 265.14631222 9.92789173 264.57256222 C10.51808302 262.14622027 11.01382074 259.71099877 11.49039173 257.26006222 C10.83039173 257.26006222 10.17039173 257.26006222 9.49039173 257.26006222 C9.65212848 256.70002876 9.81386522 256.13999531 9.98050308 255.56299114 C10.52351865 253.11044338 10.62942225 250.92406834 10.64861012 248.41319942 C10.65839893 247.44007305 10.66818775 246.46694668 10.6782732 245.46433163 C10.68402866 244.4033778 10.68978413 243.34242397 10.695714 242.24932003 C10.70561359 241.12707531 10.71551319 240.00483059 10.72571278 238.84857845 C10.75731631 235.13680288 10.78208081 231.42501451 10.80679798 227.71318722 C10.82736849 225.14057233 10.84836498 222.56796082 10.869771 219.99535275 C10.91933764 213.91458647 10.96460557 207.8338021 11.00779337 201.75298762 C11.0572081 194.82917474 11.11211049 187.90540877 11.16747296 180.98164129 C11.28121699 166.74115902 11.38807248 152.50063093 11.49039173 138.26006222 C10.83039173 138.26006222 10.17039173 138.26006222 9.49039173 138.26006222 C9.49039173 136.61006222 9.49039173 134.96006222 9.49039173 133.26006222 C9.82039173 133.26006222 10.15039173 133.26006222 10.49039173 133.26006222 C10.49039173 127.65006222 10.49039173 122.04006222 10.49039173 116.26006222 C10.16039173 116.26006222 9.83039173 116.26006222 9.49039173 116.26006222 C9.49039173 113.95006222 9.49039173 111.64006222 9.49039173 109.26006222 C9.82039173 109.26006222 10.15039173 109.26006222 10.49039173 109.26006222 C10.49039173 100.68006222 10.49039173 92.10006222 10.49039173 83.26006222 C10.16039173 83.26006222 9.83039173 83.26006222 9.49039173 83.26006222 C9.49039173 81.28006222 9.49039173 79.30006222 9.49039173 77.26006222 C10.15039173 76.93006222 10.81039173 76.60006222 11.49039173 76.26006222 C10.90137074 76.27053585 10.31234974 76.28100948 9.70547962 76.2918005 C6.98799527 76.33385776 4.27057977 76.35954402 1.55289173 76.38506222 C0.62670033 76.40182003 -0.29949108 76.41857784 -1.25374889 76.43584347 C-12.46171814 76.51449588 -22.41115708 74.2497041 -31.25960827 67.01006222 C-39.28736024 57.19836537 -43.74586285 48.16546886 -43.50960827 35.26006222 C-42.47707984 27.64516508 -40.14884275 21.37059678 -35.50960827 15.26006222 C-35.07906139 14.65549191 -34.64851452 14.05092159 -34.20492077 13.42803097 C-25.39967348 2.01105778 -13.54788353 -0.04397932 0 0 Z M66.49039173 76.26006222 C43.70762736 200.56976938 43.70762736 200.56976938 88.57242298 395.49443722 C90.30114558 397.48582346 90.30114558 397.48582346 92.49039173 397.26006222 C92.49039173 397.92006222 92.49039173 398.58006222 92.49039173 399.26006222 C121.86798882 421.98273425 158.17753683 417.41414875 193.14127851 417.40544593 C198.33139794 417.40523943 203.52151205 417.41078382 208.71162891 417.4155035 C218.84442927 417.42375406 228.97722381 417.42655569 239.11002725 417.42711588 C247.34873438 417.42759324 255.5874396 417.42965884 263.82614613 417.43281651 C287.23242554 417.44160386 310.6387004 417.44623831 334.04498148 417.44548603 C335.30265534 417.44544608 336.5603292 417.44540612 337.85611439 417.44536495 C339.11533789 417.44532407 340.3745614 417.44528319 341.67194319 417.44524107 C362.11000616 417.44483402 382.54805077 417.45442349 402.98610842 417.46850332 C424.01873759 417.48287763 445.0513578 417.48977308 466.083992 417.48890954 C477.87387527 417.48857818 489.66373923 417.49129915 501.45361805 417.50208759 C511.48148304 417.51120595 521.50931993 417.51335646 531.53718728 417.50657817 C536.6470783 417.50332118 541.75691542 417.50322685 546.86680126 417.51193142 C551.5532182 417.51983242 556.23953882 417.51832856 560.92595351 417.50964729 C562.61191655 417.50812033 564.2978869 417.50989776 565.9838413 417.51550736 C591.71808318 417.5953938 615.01650972 413.55029293 634.49039173 395.26006222 C708.65410632 318.70747249 656.49039173 182.84596915 656.49039173 76.26006222 C461.79039173 76.26006222 267.09039173 76.26006222 66.49039173 76.26006222 Z ",
    fill: "#1C1C1D",
    transform: "translate(150.5096082687378,186.7399377822876)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.14484966 -0.00644889 2.28969931 -0.01289778 3.46924138 -0.0195421 C4.71728323 -0.01644489 5.96532507 -0.01334769 7.25118637 -0.01015663 C8.59805008 -0.01389495 9.94491163 -0.0184972 11.29176974 -0.02388728 C14.98724711 -0.03611036 18.6826339 -0.03585763 22.37812686 -0.03349853 C26.36599415 -0.03309018 30.35383248 -0.04413123 34.34168625 -0.05361366 C42.15281956 -0.07022112 49.96392269 -0.0757231 57.77507219 -0.07683842 C64.1254393 -0.07778907 70.47579646 -0.0819002 76.82616043 -0.08823967 C94.83543175 -0.10585181 112.84467924 -0.11507865 130.85395923 -0.11357872 C132.31005108 -0.11345885 132.31005108 -0.11345885 133.79555893 -0.11333656 C135.2534313 -0.11321392 135.2534313 -0.11321392 136.74075565 -0.1130888 C152.48935137 -0.11227603 168.23785142 -0.1314115 183.98641947 -0.1596133 C200.16166203 -0.18835029 216.33685795 -0.20215312 232.51212668 -0.20042574 C241.59138895 -0.1997621 250.67055093 -0.2052432 259.74979019 -0.22678185 C267.48068901 -0.24500442 275.21144209 -0.24933219 282.9423531 -0.235763 C286.88490446 -0.2292386 290.82717633 -0.22909679 294.769701 -0.2464695 C298.38341484 -0.26222915 301.99662823 -0.25930764 305.61033008 -0.24190123 C307.52734071 -0.23739335 309.44436704 -0.25246607 311.36131692 -0.26838052 C320.28739284 -0.19731692 327.02613756 1.51232562 334.49526596 6.44476891 C340.91258774 13.16057076 343.5914056 20.35438718 343.45620346 29.53461266 C342.72048825 36.86023407 339.61108211 42.88416287 334.15151596 47.78851891 C323.69688411 55.58800616 310.5484344 54.40762701 298.09635544 54.39098167 C296.83345702 54.39324723 295.57055859 54.39551279 294.26939052 54.397847 C290.79850771 54.40390888 287.32764918 54.40383811 283.85676229 54.40265262 C280.10003952 54.40244719 276.34332427 54.40798075 272.58660507 54.41271019 C265.24051794 54.4209856 257.89443883 54.42376359 250.54834742 54.42432257 C244.57429703 54.42479905 238.60024928 54.42686038 232.62619972 54.43002319 C215.66365351 54.43881999 198.7011136 54.4434439 181.73856509 54.44269272 C180.8257837 54.44265276 179.91300231 54.44261281 178.97256088 54.44257164 C178.05865697 54.44253076 177.14475306 54.44248988 176.20315509 54.44244776 C161.38817752 54.4420412 146.57322535 54.45161585 131.75825513 54.46571001 C116.52185345 54.48009004 101.28546415 54.48697935 86.04905552 54.48611623 C77.50469732 54.4857849 68.96036578 54.48850398 60.41601372 54.49929428 C53.14321732 54.50842055 45.87045967 54.51055698 38.59766001 54.50378486 C34.89172633 54.50053084 31.18586693 54.50042238 27.47994041 54.50913811 C23.45195807 54.51851342 19.42414604 54.51219829 15.39616013 54.50450706 C13.66178415 54.51222241 13.66178415 54.51222241 11.89237028 54.52009362 C-11.10659903 54.42348922 -11.10659903 54.42348922 -19.81723404 46.25726891 C-25.45588051 40.12037996 -27.46408961 33.51202 -27.81723404 25.25726891 C-27.46552471 18.26704589 -24.59906453 13.26028539 -19.81723404 8.25726891 C-13.823711 2.8726496 -8.21435743 0.01174129 0 0 Z ",
    fill: "#1D1D1D",
    transform: "translate(353.81723403930664,364.74273109436035)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C244.2 0 488.4 0 740 0 C740.33 0.99 740.66 1.98 741 3 C671.01205095 2.92177256 601.02410332 2.84232128 531.03616333 2.7563324 C530.00083458 2.75506072 528.96550583 2.75378904 527.89880348 2.75247882 C505.40000981 2.72483648 482.90121643 2.69697347 460.40242331 2.66888306 C449.36951924 2.65510949 438.3366151 2.6413847 427.30371094 2.62768555 C426.20578611 2.62632146 425.10786129 2.62495738 423.97666601 2.62355196 C388.3697776 2.57933613 352.76288636 2.53834312 317.15599225 2.49901587 C280.57480886 2.45859555 243.99363074 2.41493492 207.41245615 2.36717889 C202.24931697 2.36044003 197.08617774 2.35373833 191.92303848 2.34705925 C190.90682742 2.34574352 189.89061635 2.34442779 188.84361101 2.3430722 C172.46485798 2.32196167 156.08610293 2.30428168 139.70734459 2.28787469 C123.25362815 2.27131976 106.79991924 2.25117425 90.34621172 2.22733159 C80.56273285 2.21326458 70.77925985 2.20198258 60.99577358 2.19463562 C54.46671627 2.18946178 47.93767019 2.18071115 41.40862133 2.16901226 C37.68444269 2.16244278 33.9602802 2.15746627 30.23609541 2.15683801 C26.2297274 2.15612602 22.22341203 2.14779025 18.21705437 2.1386652 C17.05362255 2.13968787 15.89019073 2.14071054 14.69150341 2.14176419 C13.0909353 2.13624313 13.0909353 2.13624313 11.45803249 2.13061053 C10.5418023 2.12951866 9.62557212 2.1284268 8.68157738 2.12730185 C5.72725706 1.98705214 2.90611769 1.53757203 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#070707",
    transform: "translate(146,187)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C28.01527425 0.10708668 56.0305208 0.21982025 84.0457449 0.33933926 C97.0527041 0.39469704 110.05966605 0.44818316 123.06665039 0.49731445 C134.39905961 0.54012506 145.73144841 0.58639504 157.06382614 0.63687855 C163.0682598 0.66350473 169.07268933 0.68835834 175.07714653 0.70907402 C180.72164954 0.72860238 186.36611361 0.75273453 192.01058197 0.78049088 C194.08874113 0.78988153 196.16690886 0.79754949 198.24508095 0.80341911 C201.0692685 0.81164623 203.89336067 0.82591303 206.71751404 0.84178162 C207.9679756 0.84324878 207.9679756 0.84324878 209.24369901 0.84474558 C214.88587879 0.88587879 214.88587879 0.88587879 216 2 C216.09897419 4.03530674 216.12632301 6.07410471 216.12698364 8.11181641 C216.12854363 8.75716654 216.13010362 9.40251667 216.13171089 10.06742287 C216.1357225 12.24549215 216.13253064 14.42349261 216.12939453 16.6015625 C216.1307485 18.15671835 216.13252841 19.71187389 216.13470459 21.26702881 C216.13927943 25.5024468 216.13748916 29.73784054 216.1343255 33.97325897 C216.13180216 38.39574756 216.13413937 42.818234 216.13571167 47.24072266 C216.13753344 54.66894912 216.13512686 62.09716566 216.13037109 69.52539062 C216.12492846 78.12605141 216.12669111 86.7266885 216.1321975 95.32734871 C216.13672841 102.69802619 216.13737929 110.06869651 216.13475883 117.43937492 C216.13319593 121.84754704 216.13300263 126.25570799 216.13629532 130.66387939 C216.13917372 134.80718348 216.13719892 138.95045687 216.13140106 143.09375763 C216.13007329 144.61881713 216.13046786 146.14387919 216.13266373 147.66893768 C216.13537459 149.74205512 216.13199493 151.81507262 216.12698364 153.88818359 C216.1264181 155.63257217 216.1264181 155.63257217 216.12584114 157.41220093 C216 160 216 160 215 161 C213.43112365 161.09591199 211.85792208 161.12187996 210.28611755 161.12025452 C209.26663025 161.12162918 208.24714294 161.12300385 207.19676208 161.12442017 C206.068918 161.12082489 204.94107391 161.11722961 203.77905273 161.11352539 C202.59872467 161.11367142 201.41839661 161.11381744 200.20230103 161.1139679 C196.95657892 161.11338895 193.71089945 161.10835986 190.46518588 161.10139394 C187.07656968 161.09515962 183.68795272 161.09455654 180.29933167 161.09336853 C173.87844196 161.09025544 167.45756919 161.08204236 161.03668696 161.07201904 C153.72846175 161.0608572 146.42023576 161.05534727 139.11200416 161.05032361 C124.07465998 161.03985973 109.03733168 161.02226073 94 161 C97.76027769 158.49314821 100.27671139 157.87489187 104.68864441 157.87974548 C105.65198196 157.87837082 106.61531952 157.87699615 107.60784912 157.87557983 C109.19064667 157.88097275 109.19064667 157.88097275 110.80541992 157.88647461 C111.91776505 157.88632858 113.03011017 157.88618256 114.17616272 157.8860321 C117.86095108 157.88673 121.54568919 157.89451669 125.23046875 157.90234375 C127.78208895 157.90420837 130.33370951 157.90563206 132.8853302 157.90663147 C138.92012123 157.91006237 144.95489061 157.91794769 150.98967296 157.92798096 C157.86022598 157.93915596 164.73077986 157.94465605 171.6013397 157.94967639 C185.73423833 157.96013067 199.86711412 157.97847061 214 158 C214 150.74 214 143.48 214 136 C213.34 136 212.68 136 212 136 C212.33 135.34 212.66 134.68 213 134 C213.08819841 131.19939211 213.11520256 128.42401857 213.09765625 125.62353516 C213.09619598 124.75448044 213.09473572 123.88542572 213.0932312 122.99003601 C213.08941435 121.09177717 213.08328651 119.19352194 213.07516479 117.29527664 C213.06234544 114.25237573 213.05586677 111.20951888 213.05102539 108.16659546 C213.03767244 100.57562028 213.01399948 92.98468445 212.98962402 85.39373779 C212.96946346 79.02749202 212.9539831 72.66126459 212.94406128 66.29499435 C212.93780067 63.36717165 212.92527963 60.43942665 212.91235352 57.5116272 C212.86448923 39.33129168 213.43501513 21.16955409 214 3 C212.92747891 3.00184359 211.85495783 3.00368717 210.7499361 3.00558662 C184.66943648 3.04995906 158.58894174 3.08283886 132.50841236 3.10362434 C119.89613823 3.11394286 107.283889 3.12801421 94.67163086 3.15087891 C83.68053044 3.17079514 72.68944807 3.18371225 61.6983301 3.18817699 C55.87706341 3.19078736 50.05584833 3.19693486 44.23459816 3.21146011 C38.7575262 3.22501608 33.28052723 3.22922665 27.80344009 3.22621536 C25.79145219 3.22676641 23.77946189 3.23075564 21.76748848 3.23841095 C19.02347579 3.24834107 16.27973973 3.24597589 13.53572083 3.24050903 C12.33775485 3.24924756 12.33775485 3.24924756 11.11558753 3.25816262 C6.96925099 3.23578938 3.72871177 2.86759719 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#151515",
    transform: "translate(270,654)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C41.36906585 0.08169432 82.73809668 0.17382996 124.10710718 0.28005161 C128.98644366 0.29257111 133.86578035 0.30500379 138.74511719 0.31738281 C139.71654237 0.31984881 140.68796755 0.3223148 141.68882985 0.32485552 C157.43669449 0.36462472 173.18456634 0.3973536 188.93245201 0.42749982 C205.08036062 0.45856778 221.22823849 0.49715706 237.37611258 0.54279006 C247.34746813 0.57072963 257.31880109 0.59273885 267.29018535 0.60726251 C274.11954218 0.61777059 280.94885537 0.63555656 287.77817939 0.65916704 C291.72365875 0.67258934 295.66907672 0.68270575 299.61458015 0.68421364 C303.22184035 0.68566275 306.82895243 0.69618475 310.4361672 0.71413441 C312.36928982 0.72133365 314.30244133 0.71863559 316.23557508 0.71566427 C317.37166074 0.72312976 318.5077464 0.73059525 319.6782589 0.73828697 C320.66477231 0.74056529 321.65128573 0.74284362 322.6676935 0.74519098 C325 1 325 1 327 3 C323.10562813 3.72214088 319.42277006 4.12515075 315.46387863 4.12584114 C314.3817301 4.12844889 313.29958156 4.13105664 312.18464065 4.13374341 C311.00663587 4.13151268 309.82863109 4.12928196 308.6149292 4.12698364 C307.35504063 4.12854363 306.09515206 4.13010362 304.79708505 4.13171089 C301.30685191 4.13588187 297.81664615 4.13382356 294.32641292 4.13072467 C290.55941887 4.12846163 286.79242952 4.13195476 283.0254364 4.13470459 C275.64744692 4.13915208 268.26946761 4.13819019 260.89147773 4.13529195 C254.89294486 4.13303323 248.89441483 4.13272743 242.89588165 4.13381577 C242.0419952 4.133969 241.18810874 4.13412223 240.30834694 4.13428011 C238.57362046 4.13459984 236.83889397 4.13492405 235.10416749 4.1352527 C218.83463096 4.13810468 202.56510005 4.13482524 186.29556444 4.12945233 C172.34498936 4.12498776 158.39442259 4.12575792 144.44384766 4.13037109 C128.23857907 4.13572736 112.03331543 4.13782664 95.82804608 4.13475883 C94.09849119 4.13444029 92.3689363 4.13412592 90.63938141 4.13381577 C89.78844838 4.13366149 88.93751536 4.13350721 88.06079648 4.13334826 C82.0736795 4.13248603 76.08656566 4.13393974 70.09944916 4.13629532 C62.79678515 4.13910533 55.49413189 4.13832985 48.1914691 4.13301457 C44.46774257 4.13039328 40.74403393 4.12934574 37.02030754 4.13266373 C32.97785803 4.13621109 28.93545337 4.13196432 24.89300537 4.12698364 C23.72392348 4.12921436 22.55484159 4.13144509 21.35033298 4.13374341 C6.17486182 4.09752289 6.17486182 4.09752289 2 3 C1.34 2.01 0.68 1.02 0 0 Z ",
    fill: "#232323",
    transform: "translate(344,415)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.82804862 -0.00043749 3.65609718 -0.00131566 5.4841454 -0.00258917 C10.44425752 -0.00479919 15.40434758 -0.00086142 20.36445689 0.0041889 C25.73702535 0.00854406 31.10959275 0.00704341 36.48216248 0.00628662 C45.76957235 0.00576457 55.05697515 0.00887789 64.34438324 0.01452446 C77.77209414 0.0226829 91.19980164 0.02525912 104.62751475 0.02651245 C126.41787716 0.02869617 148.20823582 0.03533776 169.99859619 0.04481506 C191.15452048 0.05400682 212.31044374 0.06107901 233.46636963 0.06532288 C234.77240622 0.0655856 236.07844281 0.06584832 237.42405626 0.06611901 C243.97665085 0.06742413 250.52924544 0.06868782 257.08184004 0.06993091 C311.36415328 0.08028233 365.64646245 0.09788207 419.92877197 0.12025452 C420.25877197 0.78025452 420.58877197 1.44025452 420.92877197 2.12025452 C415.57678513 2.87212473 410.36733463 3.26484661 404.95898056 3.24888897 C403.81234489 3.25151853 403.81234489 3.25151853 402.64254487 3.2542012 C400.09029146 3.25883981 397.53809556 3.25640126 394.98583984 3.25396729 C393.13387514 3.25583631 391.28191083 3.25813738 389.42994714 3.26083261 C384.34783481 3.26694521 379.26573895 3.26681766 374.18362379 3.26563823 C368.70033483 3.2654341 363.21705115 3.27095402 357.73376465 3.2756958 C346.99586393 3.28399886 336.2579687 3.28675045 325.52006504 3.28730818 C316.79603225 3.2877833 308.07200127 3.28983782 299.34796906 3.2930088 C278.64635605 3.30038052 257.94474425 3.30653378 237.24312973 3.30601025 C236.58143733 3.30599467 235.91974494 3.30597909 235.23800126 3.30596304 C231.88430565 3.30587993 228.53061004 3.30578089 225.17691442 3.30567833 C224.17783423 3.30564841 224.17783423 3.30564841 223.1585706 3.30561789 C221.81165157 3.30557745 220.46473254 3.30553566 219.11781352 3.3054925 C198.14431098 3.30487923 177.17082458 3.31239676 156.19732666 3.32606506 C132.63372622 3.341415 109.07013351 3.35001935 85.50652719 3.34910184 C73.02932518 3.34876934 60.55214139 3.35154006 48.07494354 3.36227989 C37.45748941 3.37136038 26.84006176 3.37358025 16.22260544 3.36677047 C10.80242255 3.36349343 5.38229055 3.36349111 -0.03788757 3.37212372 C-4.99447516 3.37993714 -9.95097105 3.37861061 -14.90755627 3.36983959 C-16.70549256 3.3682932 -18.50343554 3.37016314 -20.30136397 3.37569966 C-22.73595581 3.38270328 -25.17022088 3.37751095 -27.60480118 3.36914349 C-28.3107531 3.37411167 -29.01670502 3.37907985 -29.74404943 3.38419858 C-33.35593785 3.35776331 -35.99727712 3.09380079 -39.07122803 1.12025452 C-26.03452989 0.36532348 -13.05725572 -0.02374392 0 0 Z ",
    fill: "#060606",
    transform: "translate(323.07122802734375,602.8797454833984)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.71793297 0.16214003 1.43586594 0.32428006 2.17555445 0.49133343 C4.91932396 0.9854707 7.40712158 1.13033341 10.19112873 1.1386652 C11.73701395 1.14687687 11.73701395 1.14687687 13.31412917 1.15525442 C14.43961282 1.15623253 15.56509646 1.15721064 16.72468567 1.15821838 C18.52581512 1.16562535 18.52581512 1.16562535 20.36333102 1.17318195 C23.69270445 1.18588402 27.02203614 1.19417518 30.3514241 1.20060861 C33.94306561 1.20862199 37.53468598 1.22231654 41.12631226 1.23532104 C47.34788665 1.25707049 53.5694632 1.27522058 59.79105568 1.29092598 C68.78643346 1.31363856 77.78178781 1.34177947 86.77714571 1.37124526 C101.37152104 1.41890414 115.96590595 1.46217295 130.56030273 1.50268555 C144.73739365 1.54204914 158.91447606 1.58347744 173.09155273 1.62768555 C173.96542882 1.63040982 174.83930491 1.63313409 175.73966209 1.63594092 C180.1236419 1.64962054 184.50762158 1.66334078 188.8916012 1.67708123 C225.26104979 1.79101925 261.63051654 1.89783452 298 2 C298 2.66 298 3.32 298 4 C260.61424876 4.0915029 223.22851436 4.16201194 185.84267385 4.20426132 C181.43157405 4.2092643 177.02047447 4.21444158 172.609375 4.21972656 C171.29208775 4.22130043 171.29208775 4.22130043 169.94818863 4.22290608 C155.71803192 4.24032382 141.48793967 4.27186902 127.25782123 4.30861118 C112.66256578 4.34598257 98.06734414 4.36822779 83.4720428 4.37635398 C74.46181787 4.38184966 65.45177512 4.39922353 56.44160625 4.43166587 C50.2677461 4.45276686 44.0939805 4.4592101 37.92008689 4.45400551 C34.35499718 4.4514368 30.7902264 4.45544674 27.22519302 4.4768219 C23.36414106 4.49980349 19.5035081 4.49197846 15.64239502 4.48101807 C14.51010759 4.49266943 13.37782015 4.5043208 12.21122098 4.51632524 C11.17913849 4.50836104 10.14705599 4.50039685 9.08369827 4.49219131 C8.19211494 4.4937102 7.3005316 4.49522908 6.38193059 4.49679399 C3.26070498 3.84580688 2.03470948 2.38179961 0 0 Z ",
    fill: "#070708",
    transform: "translate(358,863)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.06058594 1.27875 1.12117187 2.5575 1.18359375 3.875 C1.26807216 5.5833411 1.35271641 7.29167401 1.4375 9 C1.47681641 9.83917969 1.51613281 10.67835938 1.55664062 11.54296875 C1.59853516 12.37441406 1.64042969 13.20585937 1.68359375 14.0625 C1.73858032 15.19365234 1.73858032 15.19365234 1.79467773 16.34765625 C1.95550568 18.42522443 2.21217384 20.49541158 2.50489616 22.55853271 C3.09953044 27.28627439 3.13913279 31.95609235 3.12698364 36.71582031 C3.12932363 38.13868284 3.12932363 38.13868284 3.13171089 39.59029007 C3.13568357 42.75291775 3.13254573 45.915497 3.12939453 49.078125 C3.13075023 51.35201038 3.13253111 53.62589553 3.13470459 55.89978027 C3.13925889 62.06494181 3.13749758 68.23008659 3.1343255 74.39524841 C3.13179157 80.8510645 3.13414233 87.30687917 3.13571167 93.76269531 C3.13764679 105.29766047 3.13454153 116.83261707 3.12945233 128.36758089 C3.12498487 138.81667228 3.12576098 149.26575256 3.13037109 159.71484375 C3.13572802 171.86223465 3.13771174 184.00961683 3.13475883 196.15700912 C3.1332008 202.58241798 3.13298934 209.00781918 3.13629532 215.43322754 C3.13918649 221.47427634 3.13717537 227.51530417 3.13140106 233.55635071 C3.13008016 235.77187566 3.13045621 237.98740239 3.13266373 240.20292664 C3.13540154 243.2300347 3.1319619 246.25707586 3.12698364 249.28417969 C3.12921436 250.15812 3.13144509 251.03206032 3.13374341 251.93248367 C3.11747538 257.04257738 2.73366844 261.94138108 2 267 C0.27403075 263.99805736 -0.249382 261.8511029 -0.24609566 258.40044022 C-0.25007775 257.47634299 -0.25405985 256.55224576 -0.25816262 255.60014558 C-0.25233693 254.58847754 -0.24651125 253.57680951 -0.24050903 252.53448486 C-0.24221788 251.45709289 -0.24392673 250.37970092 -0.24568737 249.26966071 C-0.24899035 245.6474803 -0.23796511 242.02548376 -0.22705078 238.40332031 C-0.22648684 235.81163029 -0.22680289 233.21993995 -0.22793579 230.62825012 C-0.22898479 225.04233129 -0.22270665 219.45645915 -0.21146011 213.87055206 C-0.19521007 205.79426275 -0.18999762 197.71799603 -0.18748413 189.64169213 C-0.18310625 176.53862179 -0.16979462 163.43557635 -0.15087891 150.33251953 C-0.13252252 137.60367965 -0.11836483 124.87484653 -0.10986328 112.14599609 C-0.10933783 111.36146715 -0.10881239 110.57693821 -0.10827102 109.76863566 C-0.10566095 105.8329075 -0.10313354 101.89717929 -0.10064721 97.96145105 C-0.07991181 65.30761591 -0.04468374 32.65381129 0 0 Z ",
    fill: "#0C0B0B",
    transform: "translate(859,263)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-1.76579834 4.49475941 -4.94221282 6.58083643 -8.8125 9.25 C-12.22044188 10.41843722 -15.41133398 10.1196222 -19 10 C-19 9.67 -19 9.34 -19 9 C-18.03900391 8.77957031 -18.03900391 8.77957031 -17.05859375 8.5546875 C-11.35771963 7.07636843 -7.58073067 5.36221227 -3.375 1.20703125 C-2 0 -2 0 0 0 Z ",
    fill: "#141313",
    transform: "translate(691,407)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.91641017 4.7578163 4.91641017 4.7578163 5.16796875 8.49609375 C5.17441406 9.46675781 5.18085937 10.43742188 5.1875 11.4375 C5.20167969 12.40558594 5.21585938 13.37367188 5.23046875 14.37109375 C5 17 5 17 3 20 C2.92652344 18.71416016 2.92652344 18.71416016 2.8515625 17.40234375 C2.45465756 11.33243544 2.00791601 5.75602589 0 0 Z ",
    fill: "#0F0F0F",
    transform: "translate(676,827)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C7.92 0.33 15.84 0.66 24 1 C24 1.33 24 1.66 24 2 C21.31300008 2.22366479 18.62656203 2.42927009 15.9375 2.625 C14.80924805 2.72167969 14.80924805 2.72167969 13.65820312 2.8203125 C8.60470937 3.17033804 4.78976864 2.66655961 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#272626",
    transform: "translate(272,602)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C1.319375 2.051875 1.319375 2.051875 0.625 3.125 C-1.01686943 6.02984591 -2.03677099 8.8139348 -3 12 C-3.33 12 -3.66 12 -4 12 C-4.50423019 6.70558305 -3.18923033 4.18586481 0 0 Z ",
    fill: "#111110",
    transform: "translate(348,824)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.81684226 1.55500981 6.19195732 4.03595495 9 7 C8.67 7.66 8.34 8.32 8 9 C6.84775972 8.07038578 5.70340824 7.1309875 4.5625 6.1875 C3.60537109 5.40439453 3.60537109 5.40439453 2.62890625 4.60546875 C1 3 1 3 0 0 Z ",
    fill: "#101010",
    transform: "translate(235,579)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C4.6875 4.5625 4.6875 4.5625 6 8 C3 8 3 8 1 7 C0.59270772 4.67843403 0.25561323 2.3431213 0 0 Z ",
    fill: "#252424",
    transform: "translate(175,581)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.63556905 1.31778453 4.72269553 3.14219898 7 5 C3.39703406 5.41176754 2.21597933 5.1535853 -0.8125 3 C-1.534375 2.34 -2.25625 1.68 -3 1 C-2.01 0.67 -1.02 0.34 0 0 Z ",
    fill: "#242323",
    transform: "translate(254,592)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C0.67 2.97 0.34 5.94 0 9 C-0.99 9.33 -1.98 9.66 -3 10 C-2.01 6.7 -1.02 3.4 0 0 Z ",
    fill: "#121212",
    transform: "translate(854,562)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.86107457 2.57404971 3.94319692 4.61020259 5 9 C4.01 9.495 4.01 9.495 3 10 C2.01 6.7 1.02 3.4 0 0 Z ",
    fill: "#151516",
    transform: "translate(219,551)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0.33 2.64 0.66 4 1 C1.36 2.98 -1.28 4.96 -4 7 C-2.73033708 1.92134831 -2.73033708 1.92134831 0 0 Z ",
    fill: "#111111",
    transform: "translate(336,371)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.66 1.98 1.32 3 2 C-1.455 3.485 -1.455 3.485 -6 5 C-5 2 -5 2 -2.625 0.6875 C-1.75875 0.460625 -0.8925 0.23375 0 0 Z ",
    fill: "#232323",
    transform: "translate(785,643)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.45925163 1.2491742 6.14693203 2.67527795 9 5 C8.01 5.495 8.01 5.495 7 6 C4.5249829 4.88568235 2.32116581 3.41849022 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#151415",
    transform: "translate(225,637)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.36591866 1.44253657 5.51047079 3.33264727 8 6 C4.65750371 5.40312566 2.53563658 4.26396123 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#121212",
    transform: "translate(210,626)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.53846154 0.61538462 5.53846154 0.61538462 7.875 2.5625 C8.431875 3.2740625 8.431875 3.2740625 9 4 C8.01 4.495 8.01 4.495 7 5 C4.5249829 3.88568235 2.32116581 2.41849022 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#242424",
    transform: "translate(336,412)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-1 3 -1 3 -2.8125 4.25 C-5.33943414 5.11637742 -6.52221994 4.88492145 -9 4 C-2.25 0 -2.25 0 0 0 Z ",
    fill: "#141413",
    transform: "translate(901,254)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 4.1875 2.75 C5.10819096 5.29960574 5.14948718 7.30923081 5 10 C0 2.5 0 2.5 0 0 Z ",
    fill: "#141413",
    transform: "translate(908,204)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.5707629 0.37586978 5.71342537 1.35671268 9 3 C5.37 2.67 1.74 2.34 -2 2 C-1.34 1.34 -0.68 0.68 0 0 Z ",
    fill: "#2C2C2C",
    transform: "translate(265,653)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-2 2 -2 2 -3.9453125 2.1953125 C-5.96354167 2.13020833 -7.98177083 2.06510417 -10 2 C-6.16991045 -0.55339303 -4.41711378 -1.47237126 0 0 Z ",
    fill: "#111111",
    transform: "translate(769,651)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.99 0.66 1.98 1 3 C-0.4375 5.6875 -0.4375 5.6875 -2 8 C-2.99 7.67 -3.98 7.34 -5 7 C-3.35 4.69 -1.7 2.38 0 0 Z ",
    fill: "#151415",
    transform: "translate(837,598)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-5.75 4 -5.75 4 -8 4 C-8 3.34 -8 2.68 -8 2 C-3.61016949 -1.20338983 -3.61016949 -1.20338983 0 0 Z ",
    fill: "#161616",
    transform: "translate(777,591)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.34058637 2.12780579 3.70700306 4.11562221 5 7 C4.01 7 3.02 7 2 7 C0 4 0 4 0 0 Z ",
    fill: "#151515",
    transform: "translate(181,590)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 4.95 1 9.9 1 15 C0.67 15 0.34 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#454545",
    transform: "translate(160,488)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 2.31 1 4.62 1 7 C0.67 7 0.34 7 0 7 C0 4.69 0 2.38 0 0 Z ",
    fill: "#454545",
    transform: "translate(160,464)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 2.31 1 4.62 1 7 C0.67 7 0.34 7 0 7 C0 4.69 0 2.38 0 0 Z ",
    fill: "#434444",
    transform: "translate(160,416)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 2.31 1 4.62 1 7 C0.67 7 0.34 7 0 7 C0 4.69 0 2.38 0 0 Z ",
    fill: "#414240",
    transform: "translate(160,376)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 2.31 1 4.62 1 7 C0.67 7 0.34 7 0 7 C0 4.69 0 2.38 0 0 Z ",
    fill: "#424242",
    transform: "translate(160,280)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#464746",
    transform: "translate(160,504)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#434343",
    transform: "translate(160,392)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#414241",
    transform: "translate(160,369)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#414243",
    transform: "translate(160,344)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.65 1 3.3 1 5 C0.67 5 0.34 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#454645",
    transform: "translate(160,456)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.65 1 3.3 1 5 C0.67 5 0.34 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#444544",
    transform: "translate(160,432)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.65 1 3.3 1 5 C0.67 5 0.34 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#434444",
    transform: "translate(160,424)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.65 1 3.3 1 5 C0.67 5 0.34 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#424241",
    transform: "translate(160,408)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.65 1 3.3 1 5 C0.67 5 0.34 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#414241",
    transform: "translate(160,384)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.65 1 3.3 1 5 C0.67 5 0.34 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#414140",
    transform: "translate(160,352)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.65 1 3.3 1 5 C0.67 5 0.34 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#424140",
    transform: "translate(160,272)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.99 1.34 1.98 1 3 C0.67 2.01 0.34 1.02 0 0 Z ",
    fill: "#454545",
    transform: "translate(481,808)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.01 1.33 1.02 1.66 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#454444",
    transform: "translate(480,680)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#4E4B4A",
    transform: "translate(520,363)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#424241",
    transform: "translate(160,328)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#424142",
    transform: "translate(160,313)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#414241",
    transform: "translate(160,305)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#4F4E4C",
    transform: "translate(634,185)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#4A4848",
    transform: "translate(603,869)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#4A4847",
    transform: "translate(633,869)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#4C4849",
    transform: "translate(607,869)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#4B4949",
    transform: "translate(577,869)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#494948",
    transform: "translate(568,869)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#4D4A4A",
    transform: "translate(551,869)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#4A4948",
    transform: "translate(488,869)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#4A4947",
    transform: "translate(473,869)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#4B4948",
    transform: "translate(432,869)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 1.67 -0.32 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#464643",
    transform: "translate(482,796)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#464545",
    transform: "translate(481,772)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 1.67 -0.32 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#474645",
    transform: "translate(482,764)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454443",
    transform: "translate(0,0)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#444343",
    transform: "translate(216,634)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474644",
    transform: "translate(0,0)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#414240",
    transform: "translate(0,0)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#434342",
    transform: "translate(0,0)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#4B4A49",
    transform: "translate(497,869)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#4A4948",
    transform: "translate(464,869)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#464545",
    transform: "translate(353,816)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454342",
    transform: "translate(0,0)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444342",
    transform: "translate(0,0)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484746",
    transform: "translate(0,0)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#454645",
    transform: "translate(481,740)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#474645",
    transform: "translate(480,731)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454644",
    transform: "translate(0,0)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454644",
    transform: "translate(0,0)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454544",
    transform: "translate(0,0)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454543",
    transform: "translate(0,0)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444343",
    transform: "translate(0,0)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484844",
    transform: "translate(0,0)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444344",
    transform: "translate(0,0)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474443",
    transform: "translate(0,0)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484646",
    transform: "translate(0,0)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464645",
    transform: "translate(0,0)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474745",
    transform: "translate(0,0)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474745",
    transform: "translate(0,0)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474745",
    transform: "translate(0,0)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464646",
    transform: "translate(0,0)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#464446",
    transform: "translate(337,368)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#434342",
    transform: "translate(0,0)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#4E4C4C",
    transform: "translate(645,363)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#4D4B4B",
    transform: "translate(631,363)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#4E4D4B",
    transform: "translate(576,363)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#4D4C4C",
    transform: "translate(551,363)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#4E4C4A",
    transform: "translate(536,363)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#4F4C4B",
    transform: "translate(512,363)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#4F4C4B",
    transform: "translate(384,363)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444343",
    transform: "translate(0,0)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#454444",
    transform: "translate(894,260)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494848",
    transform: "translate(0,0)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#4B4D49",
    transform: "translate(677,185)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F4E4A",
    transform: "translate(0,0)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#51504E",
    transform: "translate(338,185)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#4C4B49",
    transform: "translate(504,184)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2A2A29",
    transform: "translate(0,0)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#282928",
    transform: "translate(0,0)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3C3B39",
    transform: "translate(0,0)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3B3C3C",
    transform: "translate(0,0)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#393938",
    transform: "translate(0,0)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484646",
    transform: "translate(0,0)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484645",
    transform: "translate(0,0)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A4848",
    transform: "translate(0,0)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B4947",
    transform: "translate(0,0)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B4A49",
    transform: "translate(0,0)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494747",
    transform: "translate(0,0)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B4A47",
    transform: "translate(0,0)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B4947",
    transform: "translate(0,0)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B4A46",
    transform: "translate(0,0)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D4A49",
    transform: "translate(0,0)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B4A49",
    transform: "translate(0,0)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C4A4A",
    transform: "translate(0,0)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494948",
    transform: "translate(0,0)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C4A49",
    transform: "translate(0,0)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C494A",
    transform: "translate(0,0)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B4947",
    transform: "translate(0,0)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B4A4A",
    transform: "translate(0,0)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B4B48",
    transform: "translate(0,0)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B4B4A",
    transform: "translate(0,0)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D4A48",
    transform: "translate(0,0)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D4B49",
    transform: "translate(0,0)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B4849",
    transform: "translate(0,0)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C4949",
    transform: "translate(0,0)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B4A49",
    transform: "translate(0,0)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C4B49",
    transform: "translate(0,0)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B4947",
    transform: "translate(0,0)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C4948",
    transform: "translate(0,0)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A4948",
    transform: "translate(0,0)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474747",
    transform: "translate(0,0)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464747",
    transform: "translate(0,0)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444545",
    transform: "translate(0,0)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#434242",
    transform: "translate(0,0)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444245",
    transform: "translate(0,0)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454445",
    transform: "translate(0,0)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#434344",
    transform: "translate(0,0)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464546",
    transform: "translate(0,0)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#434343",
    transform: "translate(0,0)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464746",
    transform: "translate(0,0)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444445",
    transform: "translate(0,0)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494947",
    transform: "translate(0,0)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B4A49",
    transform: "translate(0,0)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B4849",
    transform: "translate(0,0)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C4C4A",
    transform: "translate(0,0)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444546",
    transform: "translate(0,0)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454543",
    transform: "translate(0,0)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474645",
    transform: "translate(0,0)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444244",
    transform: "translate(0,0)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474444",
    transform: "translate(0,0)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444442",
    transform: "translate(0,0)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474746",
    transform: "translate(0,0)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444242",
    transform: "translate(0,0)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444443",
    transform: "translate(0,0)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484745",
    transform: "translate(0,0)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474646",
    transform: "translate(0,0)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454545",
    transform: "translate(0,0)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#434343",
    transform: "translate(0,0)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474644",
    transform: "translate(0,0)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444345",
    transform: "translate(0,0)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474747",
    transform: "translate(0,0)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454544",
    transform: "translate(0,0)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474746",
    transform: "translate(0,0)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444342",
    transform: "translate(0,0)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454443",
    transform: "translate(0,0)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#434444",
    transform: "translate(0,0)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444142",
    transform: "translate(0,0)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454546",
    transform: "translate(0,0)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454545",
    transform: "translate(0,0)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484847",
    transform: "translate(0,0)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454343",
    transform: "translate(0,0)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474646",
    transform: "translate(0,0)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494848",
    transform: "translate(0,0)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454443",
    transform: "translate(0,0)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444443",
    transform: "translate(0,0)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454643",
    transform: "translate(0,0)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454344",
    transform: "translate(0,0)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#434242",
    transform: "translate(0,0)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#434443",
    transform: "translate(0,0)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454241",
    transform: "translate(0,0)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484747",
    transform: "translate(0,0)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#434341",
    transform: "translate(0,0)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3F3F3F",
    transform: "translate(0,0)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464746",
    transform: "translate(0,0)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454344",
    transform: "translate(0,0)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454444",
    transform: "translate(0,0)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474444",
    transform: "translate(0,0)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484846",
    transform: "translate(0,0)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444344",
    transform: "translate(0,0)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454342",
    transform: "translate(0,0)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494747",
    transform: "translate(0,0)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D4C4B",
    transform: "translate(0,0)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A4A49",
    transform: "translate(0,0)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444244",
    transform: "translate(0,0)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464344",
    transform: "translate(0,0)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484846",
    transform: "translate(0,0)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464645",
    transform: "translate(0,0)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B4C4A",
    transform: "translate(0,0)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484645",
    transform: "translate(0,0)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474748",
    transform: "translate(0,0)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#434444",
    transform: "translate(0,0)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454544",
    transform: "translate(0,0)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474548",
    transform: "translate(0,0)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474646",
    transform: "translate(0,0)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444443",
    transform: "translate(0,0)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494848",
    transform: "translate(0,0)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474746",
    transform: "translate(0,0)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474746",
    transform: "translate(0,0)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454344",
    transform: "translate(0,0)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444341",
    transform: "translate(0,0)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454546",
    transform: "translate(0,0)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464544",
    transform: "translate(0,0)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B4B49",
    transform: "translate(0,0)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474747",
    transform: "translate(0,0)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474745",
    transform: "translate(0,0)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484648",
    transform: "translate(0,0)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444443",
    transform: "translate(0,0)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#49484A",
    transform: "translate(0,0)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484848",
    transform: "translate(0,0)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464546",
    transform: "translate(0,0)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494647",
    transform: "translate(0,0)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474645",
    transform: "translate(0,0)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454645",
    transform: "translate(0,0)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474747",
    transform: "translate(0,0)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C4B4C",
    transform: "translate(0,0)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C4C4C",
    transform: "translate(0,0)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#49494A",
    transform: "translate(0,0)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A4B4B",
    transform: "translate(0,0)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#515251",
    transform: "translate(0,0)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494949",
    transform: "translate(0,0)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#424545",
    transform: "translate(0,0)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B4B4A",
    transform: "translate(0,0)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444544",
    transform: "translate(0,0)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444444",
    transform: "translate(0,0)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494948",
    transform: "translate(0,0)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D4C4A",
    transform: "translate(0,0)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494847",
    transform: "translate(0,0)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484747",
    transform: "translate(0,0)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444443",
    transform: "translate(0,0)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474545",
    transform: "translate(0,0)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474546",
    transform: "translate(0,0)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464748",
    transform: "translate(0,0)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#434345",
    transform: "translate(0,0)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A4948",
    transform: "translate(0,0)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D4A48",
    transform: "translate(0,0)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D4C48",
    transform: "translate(0,0)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F4B4B",
    transform: "translate(0,0)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E4D4A",
    transform: "translate(0,0)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C4D4B",
    transform: "translate(0,0)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D4D4B",
    transform: "translate(0,0)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E4D4A",
    transform: "translate(0,0)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D4C48",
    transform: "translate(0,0)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E4C49",
    transform: "translate(0,0)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D4B4A",
    transform: "translate(0,0)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D4B4B",
    transform: "translate(0,0)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E4A4C",
    transform: "translate(0,0)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D4D4B",
    transform: "translate(0,0)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E4D4B",
    transform: "translate(0,0)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F4D4C",
    transform: "translate(0,0)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F4E4B",
    transform: "translate(0,0)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F4D4D",
    transform: "translate(0,0)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E4D4C",
    transform: "translate(0,0)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C4B4A",
    transform: "translate(0,0)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E4B49",
    transform: "translate(0,0)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E4D4A",
    transform: "translate(0,0)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E4D4B",
    transform: "translate(0,0)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F4C4C",
    transform: "translate(0,0)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C4C4B",
    transform: "translate(0,0)"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C4B4A",
    transform: "translate(0,0)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D4C4C",
    transform: "translate(0,0)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E4C4A",
    transform: "translate(0,0)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E4C4A",
    transform: "translate(0,0)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E4C4A",
    transform: "translate(0,0)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E4D4A",
    transform: "translate(0,0)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E4C4A",
    transform: "translate(0,0)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D4D4C",
    transform: "translate(0,0)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D4B4A",
    transform: "translate(0,0)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D4C49",
    transform: "translate(0,0)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D4B4A",
    transform: "translate(0,0)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#504C4C",
    transform: "translate(0,0)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D4C4A",
    transform: "translate(0,0)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E4E4A",
    transform: "translate(0,0)"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D4B4A",
    transform: "translate(0,0)"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E4C4A",
    transform: "translate(0,0)"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D4D4C",
    transform: "translate(0,0)"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D4E4B",
    transform: "translate(0,0)"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#504C4B",
    transform: "translate(0,0)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E4E4E",
    transform: "translate(0,0)"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D4C4A",
    transform: "translate(0,0)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D4D4B",
    transform: "translate(0,0)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F4D4C",
    transform: "translate(0,0)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E4E4D",
    transform: "translate(0,0)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F504C",
    transform: "translate(0,0)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F4D4D",
    transform: "translate(0,0)"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B4C4B",
    transform: "translate(0,0)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#424342",
    transform: "translate(0,0)"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A4B4B",
    transform: "translate(0,0)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#424342",
    transform: "translate(0,0)"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F4F4E",
    transform: "translate(0,0)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#414143",
    transform: "translate(0,0)"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#424345",
    transform: "translate(0,0)"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474644",
    transform: "translate(0,0)"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444446",
    transform: "translate(0,0)"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464444",
    transform: "translate(0,0)"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454543",
    transform: "translate(0,0)"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464646",
    transform: "translate(0,0)"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444644",
    transform: "translate(0,0)"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474544",
    transform: "translate(0,0)"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B4848",
    transform: "translate(0,0)"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444442",
    transform: "translate(0,0)"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A4A47",
    transform: "translate(0,0)"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454647",
    transform: "translate(0,0)"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454746",
    transform: "translate(0,0)"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454746",
    transform: "translate(0,0)"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474745",
    transform: "translate(0,0)"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C4A49",
    transform: "translate(0,0)"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C4C4A",
    transform: "translate(0,0)"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D4E4E",
    transform: "translate(0,0)"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D4D4C",
    transform: "translate(0,0)"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E4E4B",
    transform: "translate(0,0)"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#504F4D",
    transform: "translate(0,0)"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E4D4D",
    transform: "translate(0,0)"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F4E4C",
    transform: "translate(0,0)"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E4D4B",
    transform: "translate(0,0)"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F4F4D",
    transform: "translate(0,0)"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E4E4C",
    transform: "translate(0,0)"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C4B48",
    transform: "translate(0,0)"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C4D49",
    transform: "translate(0,0)"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F4D4C",
    transform: "translate(0,0)"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#504F4D",
    transform: "translate(0,0)"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#504D4C",
    transform: "translate(0,0)"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#504D4C",
    transform: "translate(0,0)"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C4B49",
    transform: "translate(0,0)"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E4D4B",
    transform: "translate(0,0)"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C4E4B",
    transform: "translate(0,0)"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E4E4B",
    transform: "translate(0,0)"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F4F4D",
    transform: "translate(0,0)"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#50504D",
    transform: "translate(0,0)"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C4D49",
    transform: "translate(0,0)"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D4E4B",
    transform: "translate(0,0)"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C4D4A",
    transform: "translate(0,0)"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E4D4A",
    transform: "translate(0,0)"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E4F4C",
    transform: "translate(0,0)"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F4E4C",
    transform: "translate(0,0)"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D504E",
    transform: "translate(0,0)"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#50504D",
    transform: "translate(0,0)"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E4F4C",
    transform: "translate(0,0)"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E4F4D",
    transform: "translate(0,0)"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C4C4A",
    transform: "translate(0,0)"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#51514D",
    transform: "translate(0,0)"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A4C49",
    transform: "translate(0,0)"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E4C4B",
    transform: "translate(0,0)"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F4F4D",
    transform: "translate(0,0)"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F4E4C",
    transform: "translate(0,0)"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F4D4B",
    transform: "translate(0,0)"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E4E4C",
    transform: "translate(0,0)"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#50504F",
    transform: "translate(0,0)"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#504E4E",
    transform: "translate(0,0)"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D4D4C",
    transform: "translate(0,0)"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E4E4C",
    transform: "translate(0,0)"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F4E4D",
    transform: "translate(0,0)"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F4E4C",
    transform: "translate(0,0)"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D504D",
    transform: "translate(0,0)"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#515050",
    transform: "translate(0,0)"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E4E4D",
    transform: "translate(0,0)"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E4E4B",
    transform: "translate(0,0)"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474947",
    transform: "translate(0,0)"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494846",
    transform: "translate(0,0)"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494946",
    transform: "translate(0,0)"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494946",
    transform: "translate(0,0)"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A4A47",
    transform: "translate(0,0)"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A4948",
    transform: "translate(0,0)"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B4C49",
    transform: "translate(0,0)"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#49474A",
    transform: "translate(0,0)"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A4A4B",
    transform: "translate(0,0)"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3D3D3C",
    transform: "translate(0,0)"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#414140",
    transform: "translate(0,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentIcon);
export default __webpack_public_path__ + "static/media/presentIcon.9bc3f583.svg";
export { ForwardRef as ReactComponent };